import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

import makeStyles from '@mui/styles/makeStyles';

import _ from "lodash";

import config from "../../app/config";
import {globalVariable, setGlobalVariable} from "../../store/reducers/globals";
import ImageNative from "../../controls/imageNative";
import PerfectScrollbar from "react-perfect-scrollbar";

const useStyles = makeStyles((theme) => ({}));

function ViewDocumentNonDicom(props) {
    const dispatch = useDispatch();

    // props.
    // document = data !
    // document_id = ?
    // zoom = ?
    // pan = ?
    // background color = or is active or something like that
    // customURL function - i.e. we may use this to show nav panel
    // onClick ....
    // start at page .... maybe we should add some sort of anchors to be able to scroll there
    // native = use native lazy load ...
    //
    // what else ?

    const [zoom, setZoom] = useState(props.zoom || 300);
    const [mouseMode, setMouseMode] = useState(null);
    const [lastPosition, setLastPosition] = useState(null);

    const [actionSelected, setActionSelected] = useState(null);
    const [enhanceSelected, setEnhanceSelected] = useState(null);
    const [channelsSelected, setChannelsSelected] = useState(null);

    const [selectedDocument, setSelectedDocument] = useState(props.document);

    const variableName = "toolbarViewer" + props.viewerId;
    const toolbarViewer = useSelector(globalVariable(variableName));
    const toolbarViewerQuickAction = useSelector(globalVariable("toolbarViewerQuickAction"));

    useEffect(() => {
        if (!toolbarViewer) {
            dispatch(setGlobalVariable({
                name: variableName,
                value: {
                    channelsMode: null,
                    enhanceMode: null,
                    toolsProperties: {
                        fontSize: 16,
                        toolWidth: 3,
                    },
                    haveSquareMeasurements: false,
                    enhanceModeParameters: {
                        blur: 0,
                        brightness: 0,
                        sharpen: 0,
                        contrast: 0,
                        gamma: 0,
                    },
                    mode: "non-dicom",
                    activeMethod: "pointer",
                    activeXUP: null,
                    imageInformation: "info",
                    //relatedVisible: "related",
                    relatedFramesVisible: "related-frames",
                    documentId: selectedDocument.__id,
                },
            }));
        }
        if (toolbarViewer) {
            // setTimeout(() => {
            //
            // }, 1);
            if (actionSelected !== toolbarViewer.activeMethod) {
                // console.log("settingsChange", variableName, toolbarViewer, actionSelected, toolbarViewer.activeMethod);
                setActionSelected(toolbarViewer.activeMethod);
                // TODO: CHANGE ACTION

            }
            if (channelsSelected !== toolbarViewer.channelsMode) {
                setChannelsSelected(toolbarViewer.channelsMode);
                // TODO: CHANGE ACTION

            }
            if (enhanceSelected !== toolbarViewer.enhanceMode) {
                setEnhanceSelected(toolbarViewer.enhanceMode);
                // TODO: CHANGE ACTION

            }

            // console.log("settingsChange", variableName, props.isActive);

            // if (props.isActive) {
            //     // TODO: finish set action ... ?
            //     if (toolbarViewer.activeMethod === "zoom") {
            //         cornerstoneTools.setToolActive("Zoom", {mouseButtonMask: 1});
            //     }
            //     if (toolbarViewer.activeMethod === "pan") {
            //         cornerstoneTools.setToolActive("Pan", {mouseButtonMask: 1});
            //     }
            //     if (toolbarViewer.activeMethod === "flying-zoom") {
            //         cornerstoneTools.setToolActive("Magnify", {mouseButtonMask: 1});
            //     }
            // }
        }
    }, [toolbarViewer, props.isActive]);






    const listOfPages = React.useMemo(() => {
        const document = props.document;

        // FIXME: we need to analyse how to deal with that however I think we may find interesting idea for parametrization

        let getImageUrl = (page) => `${config.apiUrl}/patients/${props.patientId}/documents/${document.__id}/pages/${page}/preview/image?size=720&Authorization=${window.keycloak.token}`;

        // if (process.env.BUILD_MODULE === "lwh" || process.env.BUILD_MODULE === "stg" || process.env.BUILD_MODULE === "dch" || process.env.BUILD_MODULE === "mse") {
        //     getImageUrl = (page) => `${config.apiUrl}/patients/${props.patientId}/documents/${document.__id}/pages/${page}/image?Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;
        // }

        // FIXME: need to use preview !!!!
            getImageUrl = (page) => `${config.apiUrl}/patients/${props.patientId}/documents/${document.__id}/pages/${page}/image?Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;

        if(process.env.BUILD_MODULE === "main") {
            getImageUrl = (page) => `${config.apiUrl}/patients/${props.patientId}/documents/${document.__id}/pages/${page}/preview/hi/image?Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;
        }

        const pages = document.pageCount ? document.pageCount : 1;
        const scaleZoom = props.zoom ? props.zoom : 300;
        // const scaleZoom = zoom;

        let pagesListToReturn = [];
        for (let page = 0; page < pages; page++) {
            pagesListToReturn.push(
                (<div key={page} onClick={ev => ev.stopPropagation()}>
                        <div style={{marginTop: 20}}>
                            {/*<Image src={getImageUrl(page + 1)} size={scaleZoom} lazy={true} shadowed={true}/>*/}
                            {/*<ImageNative src={getImageUrl(page + 1)} size={scaleZoom} lazy={true} shadowed={true}/>*/}
                            <ImageNative src={getImageUrl(page + 1)} size={scaleZoom} lazy={true} shadowed={true}/>
                        </div>
                    </div>
                ),
            );
            pagesListToReturn.push(<div key={page + "a"} className="break"/>);
        }
        return pagesListToReturn;
    }, [props.zoom, props.document]);

    const clickOnBackground = () => {
        if (props.onClickBack) {
            props.onClickBack();
        }
    };

    const getCursorProperty = () => {
        let c = "inherit";
        if (toolbarViewer) {
            if (toolbarViewer.activeMethod === "pan") {
                c = "move";
            }
            if (toolbarViewer.activeMethod === "zoom") {
                // c = "url('/image/icon/zoom.svg')";
                // c = "url(/image/icon/zoom.svg)";
                c = "url(/image/icon/zoom2.png), auto";
            }
        }
        return c;
    };

    const lazyZoomUpdate = _.debounce((z, e) => {
        setZoom(z);
        setLastPosition(e);
    }, 1);

    const mouseDownHandler = (event) => {
        if (toolbarViewer.activeMethod === "zoom") {
            setMouseMode("zoom");
            setLastPosition(event);
        }
    }
    const mouseUpHandler = (event) => {
        setMouseMode(null);
        setLastPosition(null);
    }
    const mouseMoveHandler = (event) => {
        if (mouseMode === "zoom" && lastPosition) {
            let cx = event.clientX - lastPosition.clientX;
            let cy = event.clientY - lastPosition.clientY;

            let newZoom = zoom + (cx * 2);
            if (newZoom < 100)
                newZoom = 100;

            // noinspection all
            lazyZoomUpdate(newZoom, event);
        }
    }

    useEffect(() => {
        document.addEventListener('mouseup', mouseUpHandler);
        document.addEventListener('mousemove', mouseMoveHandler);
        return () => {
            document.removeEventListener('mouseup', mouseUpHandler);
            document.removeEventListener('mousemove', mouseMoveHandler);
        };
    }, [mouseMode]);

    return (
        // <PerfectScrollbar onScrollY={() => dispatch(updateScroll())}>
        <PerfectScrollbar>
            <div className={"viewer-non-dicom"}
            style={{
                cursor: getCursorProperty()
            }}
                 onMouseDown={mouseDownHandler}
                 // onMouseUp={mouseUpHandler}
                 // onMouseMove={mouseMoveHandler}
                 onClick={clickOnBackground}>
                {/*
                <div>
                    <Image src={imgURL} size={scaleZoom} lazy={true} shadowed={true}/>
                </div>
                <div className="break"/>
                <div style={{marginTop: 20}}>
                    <Image src={imgURL} size={scaleZoom} lazy={true} shadowed={true}/>
                </div>
                */}
                {listOfPages}
            </div>
        </PerfectScrollbar>
    );
}

export default ViewDocumentNonDicom;
